export default __webpack_public_path__ + "static/media/vertual-card-img.a03587b7.png";